var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{staticClass:"error",attrs:{"dismissible":"","value":true},on:{"input":_vm.onClose}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }